import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    mobileContent: {
      position: 'relative',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: BackgroundColors.base,
    },
    screenLayer: {
      position: 'absolute',
      inset: 0,
      '&:not([hidden])': {
        display: 'flex',
      },
      flexDirection: 'column',
      backgroundColor: BackgroundColors.base,
      isolation: 'isolate',
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
  },
  { name: 'mobileLayout' }
);

export default useStyles;
